import {combine, createEffect, createEvent, createStore} from 'effector';
import {createGate} from 'effector-react';

import {
    fetchParticipantList,
    fetchProfileCountries,
    fetchProfileInfo,
    getCredentialsFIRS,
    setCredentialsFIRS,
} from 'api';
import {updateParticipantRoles} from 'api/organizations';
import {createParticipant, removeParticipant, updateParticipant} from 'api/registration';
import {CredentialsFIRS} from 'types';
import {Country} from 'types/gtins';
import {Participant} from 'types/participants';
import {ProfileCommonInfo} from 'types/profile';

export const loadProfileCommonDataFx = createEffect({
    name: 'fetchProfileInfo',
    handler: fetchProfileInfo,
});

export const loadParticipantsDataFx = createEffect({
    name: 'fetchProfileInfo',
    handler: fetchParticipantList,
});

export const loadProfileCountiesFx = createEffect({
    name: 'fetchProfileCountries',
    handler: fetchProfileCountries,
});

export const createParticipantFx = createEffect({
    name: 'createParticipantFx',
    handler: createParticipant,
});

export const updateParticipantFx = createEffect({
    name: 'updateParticipantFx',
    handler: updateParticipant,
});

export const removeParticipantFx = createEffect({
    name: 'removeParticipantFx',
    handler: removeParticipant,
});

export const getCredentialsFIRSFx = createEffect({
    name: 'getCredentialsFIRSFx',
    handler: getCredentialsFIRS,
});

export const setCredentialsFIRSFx = createEffect({
    name: 'setCredentialsFIRSFx',
    handler: setCredentialsFIRS,
});

export const updateParticipantRolesFx = createEffect({
    name: 'updateParticipantRolesFx',
    handler: updateParticipantRoles,
});

export const ParticipantsGate = createGate('ParticipantListGate');
export const FIRSGate = createGate('FIRSGate');

export const onChangeParticipantIdForRemoveConfirmation = createEvent<number | null>();
export const onSetEditParticipant = createEvent<Participant | null>();

export const participantIdForRemoveConfirmation$ = createStore<number | null>(null);

export const data$ = createStore<ProfileCommonInfo | null>(null);

export const firs$ = createStore<CredentialsFIRS | null>(null);
export const firsState$ = combine({
    data: firs$,
    loading: getCredentialsFIRSFx.pending || setCredentialsFIRSFx.pending,
});

export const participantsList$ = createStore<Participant[]>([]);
export const editParticipantData$ = createStore<Participant | null>(null);

export const participantsState$ = combine({
    data: participantsList$,
    loading: loadParticipantsDataFx.pending,
});

export const profileCountries$ = createStore<Country[]>([]);

export const profileCountriesState$ = combine({
    data: profileCountries$,
    loading: loadProfileCountiesFx.pending,
});

export const updateParticipantRolesModalVisible$ = createStore<boolean>(false);
export const setUpdateParticipantRolesModalVisible = createEvent<boolean>();
